const loginValidationRules = [
    { 
      field: 'email', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Email is required.' 
    },
    { 
      field: 'email',
      method: 'isEmail', 
      validWhen: true, 
      message: 'Please provide a valid Email.'
    },
    
    { 
      field: 'password', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Password is required.'
    },
    { 
        field: 'password', 
        method: 'isLength', 
        args: [{min: 6, max: 20}],
        validWhen: true, 
        message: 'Password length must be between 6 to 10.'
    },
    
];

const forgotValidationRules = [
    { 
      field: 'email', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Email is required.' 
    },
    { 
      field: 'email',
      method: 'isEmail', 
      validWhen: true, 
      message: 'Please provide a valid Email.'
    },
    
];

module.exports = {

    loginValidationRules,
    forgotValidationRules

}
